// extracted by mini-css-extract-plugin
export default {"form":"RegisterPage_form__xOmj0","formGroup":"RegisterPage_formGroup__vu8gs"};